import gsap from "gsap";

export default class FiltersControls {
  constructor() {
    this.isOpen = false;
    this.filtersContainer = document.querySelector(
      "[data-js='filters-controls-container']",
    );
    this.filtersContainerElement = document.querySelector(
      "[data-js='filters-controls-container__element']",
    );
    this.filtersButtons = document.querySelectorAll(
      "[data-js='filter-controls']",
    );
    this.closeButton = document.querySelector(
      "[data-js='filters-controls-container__close']",
    );
    this.filtersContainerElementCheckedInputs =
      this.filtersContainer.querySelectorAll("input:checked");
    this.filtersCount = document.querySelectorAll(
      "[data-js='filter-controls__count']",
    );
  }

  init() {
    this.clickOutside();

    if (this.filtersContainerElementCheckedInputs.length > 0) {
      this.filtersCount.forEach((count) => {
        count.textContent = `(${this.filtersContainerElementCheckedInputs.length})`;
      });
    }

    this.filtersButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.isOpen ? this.closeFilters() : this.openFilters();
      });
    });

    this.closeButton.addEventListener("click", this.closeFilters.bind(this));
  }

  openFilters() {
    this.isOpen = true;
    document.body.style.overflow = "hidden";
    this.filtersContainer.classList.remove("hidden");

    const tl = gsap.timeline();
    gsap.set([this.filtersContainer], {
      autoAlpha: 0,
    });

    tl.set(this.filtersContainerElement, {
      xPercent: 100,
    });

    tl.to(this.filtersContainer, {
      autoAlpha: 1,
      display: "flex",
      duration: 0.3,
    });

    tl.to(this.filtersContainerElement, {
      xPercent: 0,
      duration: 0.3,
    });
  }

  closeFilters() {
    this.isOpen = false;

    const tl = gsap.timeline();

    tl.to(this.filtersContainerElement, {
      xPercent: 100,
    });

    tl.to(this.filtersContainer, {
      autoAlpha: 0,
      onComplete: () => {
        this.filtersContainer.classList.add("hidden");
        document.body.style.overflow = "auto";
      },
    });
  }

  clickOutside() {
    document.addEventListener("click", (event) => {
      if (
        this.isOpen &&
        !this.filtersContainerElement.contains(event.target) &&
        !this.filtersButtons[0].contains(event.target) &&
        !this.filtersButtons[1].contains(event.target)
      ) {
        this.closeFilters();
      }
    });
  }
}
